// extracted by mini-css-extract-plugin
module.exports = {"featuredImage":"CardKleeFeaturedImage_featuredImage__52PUS","label":"CardKleeFeaturedImage_label__jFmq7"};